// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";

export const path = "get-stations";

export const stationsSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const getStationsResponseSchema = z.object({
  receiverStations: z.array(stationsSchema),
  vendorStations: z.array(stationsSchema),
});




export type Stations = z.infer<typeof stationsSchema>;

export type GetStationsResponse = z.infer<typeof getStationsResponseSchema>;




// receiver/get-stations endpoint
export function getStations(
): Promise<GetStationsResponse> {
  return requestHandler(
    "receiver/get-stations",
    undefined,
    getStationsResponseSchema,
  );
}

